export const PAYMENTMODE_PAY_NOW = 'PAYMENTMODE_PAY_NOW';
export const PAYMENTMODE_PAY_RESERVE = 'PAYMENTMODE_PAY_RESERVE';

export const PAYMENT_METHOD_CASH = 'CASH';
export const PAYMENT_METHOD_TRANSFER = 'TRANSFER';
